import {initReactI18next} from 'react-i18next';

import i18n, {LanguageDetectorModule} from 'i18next';

import TRANSLATIONS_PT from './locales/pt.json';
import TRANSLATIONS_IT from './locales/it.json';
import TRANSLATIONS_HE from './locales/he.json';
import TRANSLATIONS_FR from './locales/fr.json';
import TRANSLATIONS_ES from './locales/es.json';
import TRANSLATIONS_EN from './locales/en.json';
import TRANSLATIONS_DE from './locales/de.json';

const supportedLanguages = ['en', 'es', 'fr', 'pt', 'de', 'he', 'it'];

const supportedRegions = {
  ca: 'es',
  gl: 'es',
  eu: 'es',
};

const defaultLanguage = 'en';

const getRegionLanguage = (language: string): string | undefined => {
  return (supportedRegions as Record<string, string>)[language];
};

const CustomLanguageDetector: LanguageDetectorModule = {
  init: () => {},
  detect: () => {
    const userLocale = navigator.language; // if system locale then window.Intl.NumberFormat().resolvedOptions().locale

    const [language, region] = userLocale.split('-');

    if (supportedLanguages.includes(language)) {
      return language;
    }

    const regionLanguage = getRegionLanguage(language);

    if (regionLanguage) {
      return regionLanguage;
    }

    return defaultLanguage;
  },
  cacheUserLanguage: () => {},
  type: 'languageDetector',
};

i18n
  .use(CustomLanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {translation: TRANSLATIONS_EN, dir: 'ltr'},
      es: {translation: TRANSLATIONS_ES, dir: 'ltr'},
      fr: {translation: TRANSLATIONS_FR, dir: 'ltr'},
      pt: {translation: TRANSLATIONS_PT, dir: 'ltr'},
      de: {translation: TRANSLATIONS_DE, dir: 'ltr'},
      he: {translation: TRANSLATIONS_HE, dir: 'rtl'},
      it: {translation: TRANSLATIONS_IT, dir: 'ltr'},
    },
  });

export const isRTL = () => {
  return i18n.dir() === 'rtl';
};

export default i18n;
